import { createContext } from 'react'

type connectionDataType = {
  rtt: number
  online: boolean
  downlink: number
  saveData: boolean
  effectiveType: string
}

declare global {
  interface Navigator {
    connection: connectionDataType
    mozConnection: connectionDataType
    webkitConnection: connectionDataType
  }
}

export type NetworkContextDataType = {
  since?: Date
  info?: connectionDataType
}

export const NetworkContext = createContext<NetworkContextDataType>({
  info: undefined,
  since: undefined
})
